import * as Cesium from "cesium";

/**
 * Add image boards (billboards as planes) to the Cesium viewer
 * @param {Cesium.Viewer} viewer
 * @param {Array} items - [{path, azimuth, coordinate:[lon,lat,height]}]
 * @param {Object} options - { width, height }
 * @param {Function} applyImageBackground
 * @returns {Object} manager { entities, destroy }
 */
export function addImageBoards(viewer, items = [], options = {}, applyImageBackground) {
  const { width = 30, height = 20 } = options;

  const entities = [];
  const handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);

  // --- create entities ---
  items.forEach((item) => {
    const [lon, lat, h] = item.coordinate;

    const entity = viewer.entities.add({
      position: Cesium.Cartesian3.fromDegrees(lon, lat, h),
      plane: {
        plane: new Cesium.Plane(Cesium.Cartesian3.UNIT_Y, 0.0),
        dimensions: new Cesium.Cartesian2(width, height),
        material: item.path,
        outline: true,
        outlineColor: Cesium.Color.BLACK,
      },
      properties: item,
    });

    // rotation by azimuth
    entity.orientation = Cesium.Transforms.headingPitchRollQuaternion(Cesium.Cartesian3.fromDegrees(lon, lat, h), new Cesium.HeadingPitchRoll(Cesium.Math.toRadians(item.azimuth), 0.0, 0.0));

    entities.push(entity);
  });

  // --- click handler ---
  handler.setInputAction((movement) => {
    const picked = viewer.scene.pick(movement.position);
    if (Cesium.defined(picked) && picked.id && picked.id.properties) {
      const data = picked.id.properties.getValue();
      console.log("Clicked data:", data);

      const [lon, lat, h] = data.coordinate;

      viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(lon, lat, h + 50),
        orientation: {
          heading: Cesium.Math.toRadians(data.azimuth),
          pitch: Cesium.Math.toRadians(-15),
          roll: 0.0,
        },
        duration: 2.0,
      });

      if (typeof applyImageBackground === "function") {
        applyImageBackground(data.path);
      }
    }
  }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

  // --- return manager ---
  return {
    entities,
    destroy: () => {
      try {
        entities.forEach((ent) => {
          if (viewer.entities.contains(ent)) {
            viewer.entities.remove(ent);
          }
        });
      } catch {}

      try {
        if (!handler.isDestroyed()) handler.destroy();
      } catch {}
    },
  };
}
